module.exports = __webpack_public_path__ + "static/media/Group-8288.0a31d658.svg";